import store from "@/store";
import request from "@/api";
import { ssoLogout, ssoLogin, ssoTicket } from "@/utils/sso.js";

let userInfo = store.getters["user/userInfo"];
const localUserInfo = window.top.localStorage.getItem("opc-userInfo");
if ((!userInfo || !userInfo.id) && localUserInfo) {
  userInfo = JSON.parse(
    window.top.localStorage.getItem("opc-userInfo") || null
  );
}
const ticket = ssoTicket();
// const ticket = ["dyli3#Abc%1234"];
export function LOGOUT() {
  store.dispatch("user/logout", null).then(() => {
    ssoLogout();
  });
}
/**
 * SSO登录的流程是：
 * 跳转SSO地址(带上登录后回跳地址redirectedPath) -> 回跳到指定链接redirectedPath(带上本次登录的ticket信息，有效期10s) ->
 * 拿ticket信息请求后端ServiceValidate接口，换取token -> 如果token失效，跳转SSO地址登出
 */
export async function validateLOGIN() {
  if (!userInfo || !userInfo.userId) {
    if (!ticket[0]) {
      store.dispatch("user/logout", null);
      ssoLogin();
      // return Promise.reject();
    } else {
      // 如果票据存在，根据票据去请求用户信息 并将用户信息持久化存储
      try {
        const tokenRes = await request({
          url: "User -> ServiceValidate",
          data: {
            ticket: ticket[0],
            service: window.location.origin + window.location.pathname
          }
        });
        console.log("ServiceValidate");
        store.dispatch("user/saveUserInfo", tokenRes.data);
        return Promise.resolve();
      } catch (error) {
        console.log("catch ServiceValidate");
        return Promise.reject();
      } finally {
        const url = window.location.href;
        const valiable = url.split("?")[0];
        window.history.pushState({}, 0, valiable);
      }
    }
  } else {
    store.dispatch("user/saveUserInfo", userInfo);
    return Promise.resolve();
  }
  return Promise.reject();
}
